/* Party & More: show one-day rentals as an event date in checkout and orders.
 * Rentshelf's private _rental_* properties remain intact for reservations. */
(() => {
  const visibleKeys = ["Rental Start", "Rental End", "Rental Duration"];

  function updateProperties(get, set, remove) {
    const start = String(get("_rental_start") || "");
    const days = String(get("_rental_days") || "");
    if (!/^\d{4}-\d{2}-\d{2}$/.test(start) || days !== "1") return;
    const displayedStart = String(get("Rental Start") || "");
    const date = new Date(`${start}T12:00:00Z`);
    const eventDate = displayedStart || new Intl.DateTimeFormat("en-US", {
      weekday: "short", month: "short", day: "numeric", year: "numeric", timeZone: "UTC"
    }).format(date);
    set("Event Date", eventDate);
    visibleKeys.forEach(remove);
  }

  function updateFormData(body) {
    const prefixes = new Set([""]);
    for (const key of body.keys()) {
      const match = key.match(/^(items\[\d+\]\[properties\])\[_rental_start\]$/);
      if (match) prefixes.add(match[1]);
    }
    for (const prefix of prefixes) {
      const name = (key) => prefix ? `${prefix}[${key}]` : `properties[${key}]`;
      updateProperties(
        (key) => body.get(name(key)),
        (key, value) => body.set(name(key), value),
        (key) => body.delete(name(key))
      );
    }
    return body;
  }

  function updateEncodedBody(body) {
    const params = new URLSearchParams(body);
    updateFormData(params);
    return params.toString();
  }

  const isCartAdd = (url) => /\/cart\/add(?:\.js)?(?:[?#]|$)/.test(String(url || ""));

  document.addEventListener("formdata", (event) => updateFormData(event.formData));

  const previousFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    const url = typeof input === "string" ? input : input?.url;
    if (isCartAdd(url) && init?.body instanceof FormData) {
      updateFormData(init.body);
    } else if (isCartAdd(url) && typeof init?.body === "string") {
      init = { ...init, body: updateEncodedBody(init.body) };
    }
    return previousFetch(input, init);
  };

  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.__partyMoreCartAdd = String(method).toUpperCase() === "POST" && isCartAdd(url);
    return originalOpen.call(this, method, url, ...rest);
  };
  XMLHttpRequest.prototype.send = function (body) {
    if (this.__partyMoreCartAdd && typeof body === "string") {
      body = updateEncodedBody(body);
    } else if (this.__partyMoreCartAdd && body instanceof FormData) {
      updateFormData(body);
    }
    return originalSend.call(this, body);
  };

  function updateAddedToCartNotice() {
    document.querySelectorAll("dl.rentshelf-cart-properties").forEach((list) => {
      const rows = [...list.querySelectorAll("dt")];
      const find = (name) => rows.find((row) => row.textContent.trim().replace(/:$/, "") === name);
      const start = find("Rental Start");
      const duration = find("Rental Duration");
      if (!start || !duration || duration.nextElementSibling?.textContent.trim() !== "1 day") return;
      start.textContent = "Event Date:";
      for (const name of ["Rental End", "Rental Duration"]) {
        const row = find(name);
        if (row) row.closest(".product-option")?.remove();
      }
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    updateAddedToCartNotice();
    new MutationObserver(updateAddedToCartNotice).observe(document.body, { childList: true, subtree: true });
  });
})();
